import ShopPage from "@pages/private/shop/ShopPage";
import ProductPage from "@pages/private/shop/ProductPage";
import CartPage from "@pages/private/shop/CartPage";
import CheckoutPage from "@pages/private/shop/CheckoutPage";
import OrdersPage from "@pages/private/shop/OrdersPage";
import AdminProductsPage from "@pages/private/shop/AdminProductsPage";
import AdminOrdersPage from "@pages/private/shop/AdminOrdersPage";
import AdminUsersPage from "@pages/private/shop/AdminUsersPage";
import ApiKeysPage from "@pages/private/shop/ApiKeysPage";
import SettingsAccountsPage from "@pages/private/Settings/Accounts";

export const PrivateRoutes = [
  { path: "/", name: "shop", component: ShopPage, guest: true },
  { path: "/product/:id", name: "product", component: ProductPage, guest: true },
  { path: "/cart", name: "cart", component: CartPage, guest: true },
  { path: "/checkout", name: "checkout", component: CheckoutPage },
  { path: "/orders", name: "orders", component: OrdersPage },
  { path: "/admin/products", name: "products", component: AdminProductsPage, admin: true },
  { path: "/admin/orders", name: "admin-orders", component: AdminOrdersPage, admin: true, store: true },
  { path: "/users", name: "users", component: AdminUsersPage, admin: true },
  { path: "/api-keys", name: "api-keys", component: ApiKeysPage, admin: true },
  { path: "/accounts", name: "account", component: SettingsAccountsPage },
];
